const AccountStatus = Object.freeze({
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
})
export default AccountStatus
// RESERVE BELOW
